<mat-card>
  <h2>Unsubscribe from Notifications</h2>
  <p>Select the notifications you wish to unsubscribe from:</p>
  <form [formGroup]="unsubscribeForm" (ngSubmit)="unsubscribe()">
    <mat-checkbox formControlName="followUpReminders">Follow-up Reminders</mat-checkbox><br>
    <mat-checkbox formControlName="healthNewsletters">Health Newsletters</mat-checkbox><br>

    <h3>Unsubscribe from All</h3>
    <mat-checkbox formControlName="unsubscribeAll">Unsubscribe from All Notifications</mat-checkbox><br><br>

    <button mat-raised-button color="primary" type="submit">Unsubscribe</button>
  </form>
</mat-card>
